import { render } from "./OutOfStockAlert.vue?vue&type=template&id=c2e6f078&scoped=true"
import script from "./OutOfStockAlert.vue?vue&type=script&lang=js"
export * from "./OutOfStockAlert.vue?vue&type=script&lang=js"

import "./OutOfStockAlert.vue?vue&type=style&index=0&id=c2e6f078&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e6f078"]])

export default __exports__